import { FC } from 'react'
import { SignUpForm } from './components/SignUpForm/SignUpForm'

type TProps = {}

const SignUpPageContent: FC<TProps> = () => {
  return (
    <div className="flex flex-1 flex-col">
      <SignUpForm />
    </div>
  )
}

export { SignUpPageContent }
